import { TypesenseProductsDocument } from 'shared-code/typesense/typesense.types'
import { DSImageProps, DSSeeMoreProductPopup } from 'shared-definitions/types'
import { pLinkMapper, PLinkMapperOpts } from './pLinkMapper'
import { imageMapper } from './imageMapper'
import { wrapWithCurrency } from 'shared-code/format'

interface Opts extends PLinkMapperOpts {
  strings: {
    compare: string
    collapse: string
    checkPrice: string
    buyButtonsSubTitle: string
    buyButtonsTitle: string
    review: string
  }
}

export function seeMoreProductPopupMapper(
  input: TypesenseProductsDocument,
  opts: Opts
): Omit<DSSeeMoreProductPopup, 'compareProducts'> {
  const priceText: string = input.prices.length
    ? wrapWithCurrency(input.prices[0].current_price.toString(), input.prices[0].currency ?? '')
    : wrapWithCurrency(input.msrp.toString(), input.msrp_currency)

  return {
    id: input.id,
    title: input.name,
    msrp: {
      price: input.msrp,
      currency: input.msrp_currency,
    },
    likes: {
      id: input.id,
      likes: input.likes,
      dislikes: input.dislikes,
    },
    images: input.images
      .map(image => imageMapper({ src: image }, opts))
      .filter(i => i !== null) as DSImageProps[],
    shortAboutProduct: {
      badges:
        (input.badges
          .flatMap(badge => badge.image.map(img => imageMapper(img, opts)))
          .filter(img => img !== null) as DSImageProps[]) ?? [],
      text: input.summary,
      ratingsPane: null,
      buyBlock: {
        hint: {
          title: opts.strings.buyButtonsTitle,
          subTitle: opts.strings.buyButtonsSubTitle,
          priceText,
        },
        rows: input.prices.map(price => ({
          button: {
            label: opts.strings.checkPrice,
            pLink: pLinkMapper(price.url ?? '', opts),
          },
          title: price.agent_name,
          priceText: wrapWithCurrency(price.current_price.toString(), price.currency ?? ''),
        })),
      },
    },
    strings: opts.strings,
    review: {
      label: opts.strings.review,
      pLink: pLinkMapper(input.review_url ?? '', opts),
    },
  }
}
